<template>
  <div class="container" style="position: relative;">
    <HeaderOther />
    <main class="about-us-main" style="margin-top: 100px">
      <div class="image-container">
      <img src="../../static/djkx1.jpeg" alt="">
      <img src="../../static/djkx2.jpeg" alt="">
      <img src="../../static/djkx3.jpeg" alt="">
      <img src="../../static/djkx4.jpeg" alt="">
      <img src="../../static/djkx5.jpeg" alt="">
      <img src="../../static/djkx6.jpeg" alt="">
      <img src="../../static/djkx7.jpeg" alt="">
      <img src="../../static/djkx8.jpeg" alt="">
      </div>
    </main>
    <Footer />
  </div>
</template>
<script >
import HeaderOther from '@/components/HeaderOther.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'AboutUs',
  components: {
    Footer,
    HeaderOther
  },
  created () {
    this.handleSelectTab(2, '简介')
  }
}

</script>



// WEBPACK FOOTER //
// src/components/AboutUs.vue